import { ChangeEvent, useEffect, useState } from "react";
import { useCreateOrUpdateCalendarEventMutation, useDeleteCalendarEventMutation, useGetCalendarEventListeMutation } from "../../../api/CalendarEventAPI";
import MaxInputAnzahlComponent from "../../../component/MaxInputAnzahlComponent";
import { ICalendarEvent, IOnlyUserProfile } from "../../../types/Types";
import { useGetUserProfilesMutation } from "../../../api/UserRoleAPI";

interface ThisProps {
}

const toLocalDateTime = (date: Date) => {
  const pad = (value: number) => String(value).padStart(2, "0");
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}:00`;
};

const AccountCalendarEventComponent: React.FC<ThisProps> = (props) => {

  const [getCalendarEventListeAPI] = useGetCalendarEventListeMutation();
  const [createOrUpdateAPI] = useCreateOrUpdateCalendarEventMutation();
  const [deleteAPI] = useDeleteCalendarEventMutation();
  const [getUserProfiles] = useGetUserProfilesMutation();

  const [liste, setListe] = useState<ICalendarEvent[]>();

  const [dto, setDto] = useState<ICalendarEvent>({ uid: "", dauerInMinuten: 30, text: "", terminISO: toLocalDateTime(new Date()) });

  const [userProfiles, setUserProfiles] = useState<IOnlyUserProfile[]>([]);

  const speichern = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    createOrUpdateAPI(dto).unwrap()
      .then(() => getListe())
      .catch((err) => console.log(err));

  };

  const getListe = () => {
    getCalendarEventListeAPI({}).unwrap()
      .then((data) => setListe(data))
      .catch((err) => console.log(err));
  }

  const changeit = (e: React.ChangeEvent<HTMLInputElement>) => {
    setDto((prevData) => ({
      ...prevData,
      [e.target.name]: e.target.value
    }));
  }

  const changedate = (e: ChangeEvent<HTMLInputElement>) => {
    const [, currentTime = "00:00"] = dto.terminISO.split("T");

    setDto((prevData) => ({
      ...prevData,
      [e.target.name]: `${e.target.value}T${currentTime.slice(0, 5)}:00`
    }));
  }

  const changetime = (e: ChangeEvent<HTMLInputElement>) => {
    const [currentDate] = dto.terminISO.split("T");
    setDto((prevData) => ({
      ...prevData,
      [e.target.name]: `${currentDate}T${e.target.value}:00`
    }));
  }

  const loeschen = (uid: string) => {
    deleteAPI(uid).unwrap()
      .then(() => getListe())
      .catch((err) => console.log(err));
  }

  useEffect(() => {
    getCalendarEventListeAPI({}).unwrap()
      .then((data) => setListe(data))
      .catch((err) => console.log(err));
  }, [getCalendarEventListeAPI]);

  useEffect(() => {

    //
    getUserProfiles().unwrap()
      .then(data => {
        setUserProfiles(data);
      });

  }, []);

  return (
    <>

      <h4 style={{ marginTop: "50px" }}>Persönliche Termine</h4>

      <form onSubmit={speichern} style={{ marginTop: "20px", marginBottom: "20px", padding: "20px", backgroundColor: "#f8f9fa" }}>

        <h4>Neuen Termin anlegen</h4>

        <div>
          <label style={{ marginRight: "10px" }}>Tag;</label>
          <input type="date" name="terminISO" value={dto.terminISO.split("T")[0]} onChange={changedate} />
        </div>
        <div>
          <label style={{ marginRight: "10px" }}>Uhrzeit</label>
          <input type="time" name="terminISO" value={dto.terminISO.split("T")[1]?.slice(0, 5) ?? "00:00"} onChange={changetime} />
        </div>
        <div>
          <label style={{ marginRight: "10px" }}>Dauer in Minuten:</label>
          <input type="number" name="dauerInMinuten" value={dto?.dauerInMinuten} onChange={changeit} />
        </div>
        <div>
          <label htmlFor="selectBesitzerUid">Besitzer:</label>
          <select name="besitzerUid" id="selectBesitzerUid" value={dto.besitzerUid} onChange={(e) => { setDto((prevData) => ({ ...prevData, [e.target.name]: e.target.value })) }} >
            <option value={""}>--- Bitte auswählen ---</option>
            {userProfiles.map((user, index) => {
              return <option key={index} value={user.uid}>{user.name}</option>;
            })}
          </select>
        </div>
        <div>
          <label style={{ marginRight: "10px" }}>Text</label>
          <textarea style={{ width: "100%" }} rows={5} maxLength={255} name="text" value={dto?.text} onChange={(e) => setDto((prevData) => ({ ...prevData, [e.target.name]: e.target.value }))} ></textarea>
          <MaxInputAnzahlComponent aktuell={dto?.text.length} max={255} />
        </div>

        <div><button className="btn btn-primary" type="submit" >Speichern</button></div>

      </form>

      {liste &&
        <>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr 1fr 1fr 1fr", rowGap: "20px", padding: "40px", backgroundColor: "white" }}>

            <div>Tag</div>
            <div>Uhrzeit</div>
            <div>Dauer</div>
            <div>Text</div>
            <div>Besitzer</div>
            <div>Option</div>
            {liste.map((dto: ICalendarEvent) => (
              <>
                <div>
                  {dto.terminISO.split("T")[0]}
                </div>
                <div>
                  {dto.terminISO.split("T")[1]?.slice(0, 5) ?? "00:00"}
                </div>
                <div>
                  {dto.dauerInMinuten}
                </div>
                <div>
                  {dto.text}
                </div>
                <div>
                  {userProfiles.find((profile) => profile.uid === dto.besitzerUid)?.name ?? "Unbekannt"}
                </div>
                <div><button className="btn btn-danger" onClick={() => loeschen(dto.uid)}><i className="bi bi-trash"></i> Löschen</button></div>
              </>
            ))}
          </div>
        </>
      }

    </>
  );
}

export default AccountCalendarEventComponent;
